const team = [
  {
    id: 1,
    img: "/assets/img/team/team_2_1.jpg",
    name: "Rayan Athels",
    designation: "Founder & CEO",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 2,
    img: "/assets/img/team/team_2_2.jpg",
    name: "Alex Furnandes",
    designation: "Project Manager",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 3,
    img: "/assets/img/team/team_2_3.jpg",
    name: "Mary Crispy",
    designation: "Chief Expert",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 4,
    img: "/assets/img/team/team_2_4.jpg",
    name: "Henry Joshep",
    designation: "Product Manager",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 5,
    img: "/assets/img/team/team_2_5.jpg",
    name: "Sanjida Carlose",
    designation: "IT Consultant",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 6,
    img: "/assets/img/team/team_1_6.jpg",
    name: "Sanjida Carlose",
    designation: "Head Manager",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 7,
    img: "/assets/img/team/team_1_7.jpg",
    name: "Sanjida Carlose",
    designation: "Web Developer",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
  {
    id: 8,
    img: "/assets/img/team/team_1_8.jpg",
    name: "Sanjida Carlose",
    designation: "UI/UX Designer",
    biography: {
      title: "Personal Biography",
      description:
        "Conveniently innovate professional initiatives whereas virtual information. Compellingly network resource maximizing materials without premier benefits. Phosfluorescently synthesize wireless solutions with robust e-business. Monotonectally implement functionalized ideas with technically sound process improvements. Dramatically disseminate vertical systems after.",
    },

    professionalSkills: {
      title: "Professional Skills",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather. Process tonectall incentivize installed base intellectual flexible.",

      skills: [
        {
          id: 1,
          title: "Team Experience",
          percentage: 95,
        },
        {
          id: 2,
          title: "Project Success",
          percentage: 90,
        },
        {
          id: 3,
          title: "Positive Review",
          percentage: 85,
        },
      ],
    },

    activities: {
      title: "Activities",
      description:
        "Energistically myocardinate parallel market with co effective channel. Competently e-enable proactive relationships with stand-alone infomediaries.",

      checklist: [
        "Experienced Attorneys Professional.",
        "Experienced Attorneys Approach.",
        "Independence Makes Difference.",
        "Committed To Helping Our Clients.",
      ],
    },

    education: {
      title: "Educational Qualification",
      description:
        "Credibly scale plug-and-play customer service after high-payoff idea. Monotonectall incentivize installed base intellectual capital whereas flexible process improvement. Conveniently. Distinctively negotiate front-end customer service rather.",

      experiences: [
        {
          id: 1,
          order: "1st",
          title: "IT Consultant",
          duration: "2016 - Present (Webteck.Inc)",
        },
        {
          id: 2,
          order: "2nd",
          title: "Software Developer",
          duration: "2010 - 2015 (Lazmi Trade)",
        },
        {
          id: 3,
          order: "3rd",
          title: "Junior Innovator",
          duration: "2006 - 2009 (Onium Plan)",
        },
        {
          id: 4,
          order: "4th",
          title: "Junior Developer",
          duration: "2000 - 2005 (Grages.Ltd)",
        },
      ],
    },
  },
];

export default team;
